import React from 'react'
import PhotosTab from '../../components/Landing/PhotosTab'

const PhotosPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      {/* Welcome Header */}
      <div className="mb-8">
        <div className="bg-gradient-to-r from-pink-500 to-red-600 rounded-2xl p-8 text-white relative overflow-hidden">
          <div className="relative z-10">
            <h1 className="text-4xl font-bold mb-4">
              Photos
            </h1>
            <p className="text-pink-100 text-lg mb-6">
              Browse and manage your photo library
            </p>
          </div>
          
          {/* Background Pattern */}
          <div className="absolute top-0 right-0 w-64 h-64 opacity-10">
            <svg viewBox="0 0 200 200" className="w-full h-full">
              <defs>
                <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
                  <path d="M 20 0 L 0 0 0 20" fill="none" stroke="currentColor" strokeWidth="1"/>
                </pattern>
              </defs>
              <rect width="200" height="200" fill="url(#grid)" />
            </svg>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        <PhotosTab />
      </div>
    </div>
  )
}

export default PhotosPage
